var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 18.75C17.2376 20.4162 12.7601 20.4162 10.0001 18.75M23.7501 10.8875L17.0838 5.70249C16.4988 5.24737 15.7788 5.00027 15.0376 5.00027C14.2964 5.00027 13.5764 5.24737 12.9913 5.70249L6.32385 10.8875C5.92315 11.1991 5.59896 11.5981 5.37604 12.0542C5.15312 12.5102 5.03736 13.0111 5.0376 13.5187V22.5187C5.0376 23.1818 5.30099 23.8177 5.76983 24.2865C6.23867 24.7553 6.87456 25.0187 7.5376 25.0187H22.5376C23.2006 25.0187 23.8365 24.7553 24.3054 24.2865C24.7742 23.8177 25.0376 23.1818 25.0376 22.5187V13.5187C25.0376 12.49 24.5626 11.5187 23.7501 10.8875Z",
    stroke: "#3C3C3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShome);
export default __webpack_public_path__ + "static/media/shome.b38845e6703dea847928d4fa701bdbe1.svg";
export { ForwardRef as ReactComponent };